import { YZip } from 'utils/YupUtils';
import * as Yup from 'yup';

export const YDisorderPage = Yup.object().shape({
  zip: YZip,
});
